import CssBaseline from "@mui/material/CssBaseline";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { useAppSelector } from "app/hooks";
import { SidebarDrawer } from "components/Sidebar/SidebarDrawer";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import React from "react";
import { selectInformationsHeight } from "reduxState/informations/informationsSlice";

const useStyles = makeStyles<OLTheme, { informationsHeight: number }>(
  (theme: OLTheme) =>
    createStyles({
      content: {
        padding: theme.spacing(0, 9.5),
        display: "flex",
        flexDirection: "column",
        width: "100%",
        overflowX: "hidden",
        backgroundColor: theme.white00,
        position: "relative",
        marginTop: ({ informationsHeight }) => `${informationsHeight}px`,
      },
      root: { display: "flex", minHeight: "100%", flex: 1 },
    }),
);
type Props = {
  children?: React.ReactNode;
};

export function LayoutComponent({ children }: Props) {
  const informationsHeight = useAppSelector(selectInformationsHeight);
  const classes = useStyles({ informationsHeight: informationsHeight });

  return (
    <div className={classes.root}>
      <CssBaseline />
      <SidebarDrawer />
      <main className={classes.content}>{children}</main>
    </div>
  );
}
